export default {
  achievementssearch: {
    purOfficeNo: '采购中心',
    performanceDate: '绩效时间',
    qualifiedBatchScore: '合格批率',
    priceDifferenceScore: '目标价格差率',
    committedDeliveryScore: '承诺交期达成率',
    expectedDeliveryScore: '期望交期达成率',
    qualifiedReceiptScore: '合格收货率',
    barDataTitle: '预算分配',
    barTitle: '绩效雷达图',
    pieTitle: '绩效折线图',
    systemScore: '系统分数',
    performanceScore: '绩效分数',
    qualitativeScore: '定性分数'
  }
}
